import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

const breakpoints = {
  tablet: 768,
  phone:  480,
};

const TAB_HOVER_COLOR = "#F7941D";

const TabsContainer = styled.ul`
  display: flex;
  justify-content: center;
  list-style: none;
  border-bottom: 2px solid #ccc;
  padding-left: 0;
  margin: 0;

  /* by default each tab sits naturally */
  li {
    margin-right: 15px;
    margin-bottom: 30px;
  }

  a {
    display: inline-block;
    text-decoration: none;
    padding: 10px 15px;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: ${({ colors }) => colors.titleText};
    color: ${({ colors }) => colors.buttonBackground};
    font-weight: 600;
    transition: all 0.2s;

    &.selected {
      background-color: ${({ colors }) => colors.buttonBackground};
      color: #fff;
      border-color: ${({ colors }) => colors.buttonBackground};
    }

    &:hover:not(.selected) {
      background-color: ${TAB_HOVER_COLOR};
      border-color: ${TAB_HOVER_COLOR};
      color: #fff;
    }
  }

  @media (max-width: ${breakpoints.tablet}px) {
    justify-content: flex-start;
    overflow-x: auto;
    padding: 0 10px;
    -webkit-overflow-scrolling: touch;

    /* keep them all on one line */
    flex-wrap: nowrap;

    li {
      flex: 0 0 auto;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }

  @media (max-width: ${breakpoints.phone}px) {
    li {
      margin-right: 6px;
    }
    a {
      padding: 8px 12px;
      font-size: 0.9rem;
    }
  }
`;

const ISAFE_ROLES = new Set([
  "isafe_accountant",
  "isafe_moderator",
  "isafe_salesperson",
  "isafe_admin",
  "root",
]);
const SUBSCRIPTION_ROLES = new Set([
  "subscription_access",
  "subscription_accountant",
  "subscription_admin",
  "subscription_implementor",
  "subscription_salesperson",
]);

export default function SubscriptionTabs({
  colors,
  selectedTab,
  handleTabClick,
}) {
  const become = useSelector((s) => s.auth.become);
  const roles = useSelector((s) => s.auth.user.roles || []);

  const isISAFEAdmin =
    become === 0 && roles.some((r) => ISAFE_ROLES.has(r.id));
  const isSubscriptionAdmin =
    become === 1 || roles.some((r) => SUBSCRIPTION_ROLES.has(r.id));

  let tabs = [];
  if (isISAFEAdmin) {
    tabs = [
      "Subscriptions",
      "Report Download Log",
      "Import Invoices",
      "POC Updates",
      "Expiring Subscriptions",
    ];
  } else if (isSubscriptionAdmin) {
    tabs = ["Announcements", "Point of Contact", "Renew Subscription"];
  }

  return (
    <TabsContainer colors={colors}>
      {tabs.map((tab) => (
        <li key={tab}>
          <a
            href="#"
            className={selectedTab === tab ? "selected" : ""}
            onClick={(e) => {
              e.preventDefault();
              handleTabClick(tab);
            }}
          >
            {tab}
          </a>
        </li>
      ))}
    </TabsContainer>
  );
}
